/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LicenseFeatureRepresentation
 */
export interface LicenseFeatureRepresentation {
    /**
     * 
     * @type {string}
     * @memberof LicenseFeatureRepresentation
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof LicenseFeatureRepresentation
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof LicenseFeatureRepresentation
     */
    expiresAtSeconds: number;
}

/**
 * Check if a given object implements the LicenseFeatureRepresentation interface.
 */
export function instanceOfLicenseFeatureRepresentation(value: object): value is LicenseFeatureRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('expiresAtSeconds' in value) || value['expiresAtSeconds'] === undefined) return false;
    return true;
}

export function LicenseFeatureRepresentationFromJSON(json: any): LicenseFeatureRepresentation {
    return LicenseFeatureRepresentationFromJSONTyped(json, false);
}

export function LicenseFeatureRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseFeatureRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'expiresAtSeconds': json['expiresAtSeconds'],
    };
}

export function LicenseFeatureRepresentationToJSON(json: any): LicenseFeatureRepresentation {
    return LicenseFeatureRepresentationToJSONTyped(json, false);
}

export function LicenseFeatureRepresentationToJSONTyped(value?: LicenseFeatureRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'expiresAtSeconds': value['expiresAtSeconds'],
    };
}

